import update from 'immutability-helper';
import {
  CLEAR_YOUTUBE_STATE,
  OPEN_YOUTUBE_SORT_LAYER, CLOSE_YOUTUBE_SORT_LAYER,
  SET_YOUTUBE_SEARCH_QUERY, SET_YOUTUBE_SORT_OPTION,
  SEARCH_YOUTUBE_VIDEOS, INIT_YOUTUBE_VIDEOS,
  SEARCH_MORE_YOUTUBE_VIDEOS, APPEND_YOUTUBE_VIDEOS
} from './action-types';
import { sortOption } from '../constants/youtube';


const initialState = {
  isOpen: false,
  isSearched: false,
  searchQuery: '',
  sortOption: sortOption.relevance.VAL,
  isSortLayerOpen: false,
  videos: [],
  isFetching: false,
  isFetchingMore: false,
  nextPageToken: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_YOUTUBE_STATE:
      return update(state, {
        $set: initialState,
      });
    case SET_YOUTUBE_SEARCH_QUERY:
      return update(state, {
        searchQuery: { $set: action.searchQuery },
      });
    case OPEN_YOUTUBE_SORT_LAYER:
      return update(state, {
        isSortLayerOpen: { $set: true },
      });
    case CLOSE_YOUTUBE_SORT_LAYER:
      return update(state, {
        isSortLayerOpen: { $set: false },
      });
    case SET_YOUTUBE_SORT_OPTION:
      return update(state, {
        sortOption: { $set: action.sortOption },
      });
    case SEARCH_YOUTUBE_VIDEOS:
      return update(state, {
        isFetching: { $set: true },
        isSearched: { $set: true },
      });
    case INIT_YOUTUBE_VIDEOS:
      return update(state, {
        isFetching: { $set: false },
        videos: { $set: action.videos },
        nextPageToken: { $set: action.nextPageToken },
      });
    case SEARCH_MORE_YOUTUBE_VIDEOS:
      return update(state, {
        isFetchingMore: { $set: true },
      });
    case APPEND_YOUTUBE_VIDEOS:
      return update(state, {
        isFetchingMore: { $set: false },
        videos: { $push: action.videos },
        nextPageToken: { $set: action.nextPageToken },
      });
    default:
      return state;
  }
};

export default reducer;
